import { Component, _decorator } from 'cc';
import Lobby from '../../../System/Lobby';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';
import ValueSlider from '../../../../common/scripts/Toolkit/Components/ValuePicker/ValueSlider';
import ValueSelector from '../../../../common/scripts/Toolkit/Helper/ValueSelector';
import { getArithmeticSequence } from '../../../../common/scripts/Toolkit/Utils/Utility';
import { GameSettingName } from '../../../../tableEngine/Script/Game/Data/Model/SettingModel';
import { BGMOption } from './BGMDropdown';
import SupportLanguage from '../../../../common/scripts/I18n/SupportLanguage';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('SettingPage')
@requireComponent(Page)
export default class SettingPage extends Component {
    // @property(Toggle)
    // private readonly soundToggle: Toggle = null;

    @property(ValueSlider)
    private readonly soundVolumeSlider: ValueSlider = null;

    // @property(Toggle)
    // private readonly musicToggle: Toggle = null;

    @property(ValueSlider)
    private readonly musicVolumeSlider: ValueSlider = null;

    // @property(Toggle)
    // private readonly machineSoundToggle: Toggle = null;

    @property(Dropdown)
    private readonly languageDropdown: Dropdown<SupportLanguage> = null;

    @property(Dropdown)
    private readonly bgmDropdown: Dropdown<BGMOption> = null;

    // @property(Node)
    // private readonly machineSoundTab: Node = null;

    private _page: Page = null;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    public onLoad() {
        Lobby.setting[GameSettingName.PreferredLanguage] = Lobby.i18n.currentLanguage;

        const volumeRange = getArithmeticSequence(0, 100);
        this.soundVolumeSlider.init(new ValueSelector([...volumeRange]));
        this.musicVolumeSlider.init(new ValueSelector([...volumeRange]));

        // this.soundToggle.node.on(Toggle.EventType.TOGGLE, this._onSoundToggleChanged, this);
        // this.musicToggle.node.on(Toggle.EventType.TOGGLE, this._onMusicToggleChanged, this);
        this.soundVolumeSlider.node.on(ValueSlider.EVENT_TYPE.VALUE_CHANGED, this._onSoundVolumeChanged, this);
        this.musicVolumeSlider.node.on(ValueSlider.EVENT_TYPE.VALUE_CHANGED, this._onMusicVolumeChanged, this);
        // this.machineSoundToggle.node.on(Toggle.EventType.TOGGLE, this._onMachineSoundToggleChanged, this);
        this.bgmDropdown.node.on(Dropdown.EVENT_TYPE.OPTION_CLICKED, this._onBGMOptionClick, this);
        this.languageDropdown.node.on(Dropdown.EVENT_TYPE.OPTION_CLICKED, this._onLanguageOptionClick, this);

        this.page.on(Page.EVENT_TYPE.OPEN_START, () => {
            this.soundVolumeSlider.value = Math.floor(Lobby.audio.effectVolume * 100);
            this.musicVolumeSlider.value = Math.floor(Lobby.audio.musicVolume * 100);
        });
        // Set initial values
        this.page.once(Page.EVENT_TYPE.OPEN_START, () => {
            // this.soundToggle.isChecked = Lobby.audio.effectMute;
            // this.musicToggle.isChecked = Lobby.audio.musicMute;
            // this.machineSoundToggle.isChecked = Lobby.setting.MachineSoundMute;
            this.bgmDropdown.selectedOptionValue = Lobby.setting.BGM ?? BGMOption.Random;
            this.languageDropdown.selectedOptionValue = Lobby.i18n.currentLanguage;
        });

        // handle dropdown z-index
        function onDropdownOpen(dropdown: Dropdown) {
            // ensure dropdown is on top of other dropdowns
            dropdown.node.zIndex = 2;
        }
        function onDropdownClose(dropdown: Dropdown) {
            // reset dropdown z-index but still keep it on top of other elements
            dropdown.node.zIndex = 1;
        }
        this.bgmDropdown.node.on(Page.EVENT_TYPE.OPEN_START, () => onDropdownOpen(this.bgmDropdown));
        this.bgmDropdown.node.on(Page.EVENT_TYPE.OPEN_START, () => onDropdownClose(this.bgmDropdown));
        this.languageDropdown.node.on(Page.EVENT_TYPE.OPEN_START, () => onDropdownOpen(this.languageDropdown));
        this.languageDropdown.node.on(Page.EVENT_TYPE.OPEN_START, () => onDropdownClose(this.languageDropdown));
        // register event and reopen in start
        this.page.close();
    }

    public start() {
        this.page.open();
    }

    private _showMachineSoundToggle() {
        // only show machine sound toggle in game
        // const show = !!Lobby.currentTable;
        // this.machineSoundToggle.node.active = show;
        // this.machineSoundTab.active = show;
    }

    // private _onSoundToggleChanged() {
    //     Lobby.audio.effectMute = this.soundToggle.isChecked;
    //     Lobby.setting.EffectMute = this.soundToggle.isChecked;
    //     this.soundVolumeSlider.value = this.soundToggle.isChecked ? 0 : Lobby.audio.rawEffectVolume * 100;
    // }

    // private _onMusicToggleChanged() {
    //     Lobby.audio.musicMute = this.musicToggle.isChecked;
    //     Lobby.setting.MusicMute = this.musicToggle.isChecked;
    //     this.musicVolumeSlider.value = this.musicToggle.isChecked ? 0 : Lobby.audio.rawMusicVolume * 100;
    // }

    private _onSoundVolumeChanged(value: number) {
        // if (!this.soundToggle.isChecked || value) {
        if (value) {
            Lobby.audio.effectVolume = value / 100;
            Lobby.setting.EffectVolume = value / 100;
        }
        // this.soundToggle.isChecked = !value;
    }

    private _onMusicVolumeChanged(value: number) {
        // if (!this.musicToggle.isChecked || value) {
        if (value) {
            Lobby.audio.musicVolume = value / 100;
            Lobby.setting.MusicVolume = value / 100;
        }
        // this.musicToggle.isChecked = !value;
    }

    private _onMachineSoundToggleChanged() {
        // Lobby.setting.MachineSoundMute = this.machineSoundToggle.isChecked;
    }

    private _onLanguageOptionClick() {
        Lobby.setting[GameSettingName.PreferredLanguage] = this.languageDropdown.selectedOptionValue;
    }

    private _onBGMOptionClick() {
        Lobby.setting[GameSettingName.BGM] = this.bgmDropdown.selectedOptionValue;
    }
}
